<template>
  <div class="Productstable-div">
    <div class="Productstable-th">
      <div class="Productstable-td Productstable-td1">标题</div>
      <div class="Productstable-td Productstable-td2">版本号</div>
      <div class="Productstable-td Productstable-td3">更新日期</div>
      <div class="Productstable-td Productstable-td4">操作</div>
    </div>
    <div class="Productstable-tbody">
      <div class="Productstable-tbody-tr"
           v-for="(item, index) in fileList" :key="index">
        <div class="Productstable-td Productstable-td1">
          <!-- <img :src="require('../assets/images/table-icon.png')"> -->
          <div class="Productstable-td1-con">
            <div class="Productstable-td1-title">{{item.title}}</div>
            <div class="Productstable-td1-tip">{{item.introduction}}</div>
          </div>
        </div>
        <div class="Productstable-td Productstable-td2">
          {{item.version}}
        </div>
        <div class="Productstable-td Productstable-td3">
          {{item.updateTime}}
        </div>
        <div class="Productstable-td Productstable-td4">
          <a :href="item.url" target="_blank">
            下载
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Productstable",
    props: {
      fileList: {
        type: Array,
        default: [],
      },
    },
    data() {
    	return {
        tablelist: [{
          title: "MC32F7361用户手册",
          titleicon: require("../assets/images/table-icon.png"),
          titletip: "8 位 RISC CPU, 2K×16bit FLASH, 256 byte SRAM, 128×16bit EEPROM, 通用 ADC 类 MCU",
          vsion: "Rb33P165A",
          time: "2021-21-21",
          doingurl: ""
        },
        {
          title: "MC32F7361用户手册",
          titleicon: require("../assets/images/table-icon.png"),
          titletip: "8 位 RISC CPU, 2K×16bit FLASH, 256 byte SRAM, 128×16bit EEPROM, 通用 ADC 类 MCU",
          vsion: "Rb33P165A",
          time: "2021-21-21",
          doingurl: ""
        }]
      }
    },
    mounted() {},
    methods: {
      gourl(url) {
        window.open = url;
      }
    }
  };
</script>

<style scoped>
  .Productstable-div {
    width: 100%;
  }
  
  .Productstable-th {
    background-color: #f5f5f5;
    color: #262626;
    font-weight: bold;
    font-size: 14px;
    display: flex;
  }
  
  .Productstable-td {
    margin: 15px 10px;
    border-left: 1px solid #ccc;
    padding-left: 15px;
    flex-shrink: 0;
  }
  
  .Productstable-td:first-child,
  .Productstable-tbody-tr .Productstable-td {
    border: none;
  }
  
  .Productstable-td1 {
    width: 40%;
    display: flex;
  }
  
  .Productstable-td2,
  .Productstable-td3,
  .Productstable-td4 {
    width: 20%;
  }
  
  .Productstable-td4 a {
    text-decoration: none;
  }
  
  .Productstable-tbody-tr {
    display: flex;
    box-sizing: border-box;
    font-size: 14px;
    color: #4c4c4c;
    border-bottom: 1px solid #f5f5f5;
  }
  
  .Productstable-tbody-tr .Productstable-td4 {
    color: #232CEA;
  }
  
  .Productstable-td1 img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    margin-top: 5px;
  }
  
  .Productstable-td1-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  
  .Productstable-td1-tip {
    font-size: 12px;
    color: #787878;
    margin-top: 10px;
    line-height: 24px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
</style>